import React from 'react';
import { Link } from 'react-router-dom';
import { search } from '../../../../api';
import { ROUTING } from '../../../../constants';
import './SearchResults.css';

const SearchResults = (props) => {
  const { term } = props;
  const results =
    term.length === 0
      ? []
      : search(term).map(result => (
        <Link
          className="search-result"
          key={result[0]}
          to={`${ROUTING.DETAIL}/${result[0]}`}
        >
          {result[1].title}
        </Link>
      ));

  return <div id="search-results">{results}</div>;
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/components/App/SearchBox/SearchResults/SearchResults.js